import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-gce-reports',
  templateUrl: './gce-reports.component.html',
  styleUrls: ['./gce-reports.component.css']
})
export class GceReportsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
